import React from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import useGetUrlLocale from "../../../hooks/useGetUrlLocale";

interface NoProjectModalProps {
  showModal: boolean;
  closeModal: () => void;
}

const NoProjectModal: React.FC<NoProjectModalProps> = ({
  showModal,
  closeModal,
}) => {
  const { t } = useTranslation();
  const lng = useGetUrlLocale();
  return (
    <>
      <Modal show={showModal} onHide={closeModal} centered>
        <Modal.Header closeButton className="border-0">
          <Modal.Title> {t("copyModal.createTitle")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="mb-4 text-center px-3 text-gray">
            {t("copyModal.createDescription")}
          </p>
          <Row className="gx-2 mt-4">
            <Col lg={6}>
              <Button
                variant="outline-dark"
                onClick={() => closeModal()}
                className="w-100 fw-normal mb-4 mb-lg-0 dark-hover"
              >
                {t("projects.deleteCancel")}
              </Button>
            </Col>
            <Col lg={6}>
              <Link
                to={`${lng}/projects/new`}
                className="w-100 text-white btn btn-primary"
              >
                {t("copyModal.create")}
              </Link>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default NoProjectModal;
